import { useAppTranslation } from '@hooks';
import { css } from '@emotion/react';
import { PropsWithChildren } from 'react';
import { IText } from '@types';
import { Row, Col, Title, Space, Content } from 'common-components';

export type HeaderContributorsPropsType = {
  countContributorsSelected: number
};

const HeaderContributors = ({
  countContributorsSelected,
  children,
}: PropsWithChildren<HeaderContributorsPropsType>) => {
  const { translate } = useAppTranslation();

  const texts: IText[] = [
    {
      type: 'tablePageTitle',
      content:
        countContributorsSelected > 0
          ? `${countContributorsSelected} ${
            countContributorsSelected === 1
              ? translate('contributors.selectedContributor')
              : translate('contributors.selectedContributors')
          }`
          : translate('contributors.contributors'),
    },
    {
      type: 'tablePageSubtitle',
      content: translate('contributors.manageTeamMembers'),
    },
  ];

  return (
    <Content>
      <Row
        justify={'space-between'}
        align={'top'}
        wrap={false}
        css={css`
          margin: 24px 0;
          gap: 16px;
        `}
      >
        <Col
          css={css`
            flex: 1;
            min-width: 0;
          `}
        >
          {texts.map((text, index) => (
            <Title key={`title-${text.content}-${index}`} preset={text.type}>
              {text.content}
            </Title>
          ))}
        </Col>
        <Row>
          <Space>{children}</Space>
        </Row>
      </Row>
    </Content>
  );
};

export default HeaderContributors;
